<template>
  <div class="cate-product">
    <el-image style="width:100%;height:200.91px;" :src="item.cover_image" :key="item.cover_image" fit="contain" :alt="item.goods_name"></el-image>
    <div class="product-box">
      <p class="goods_name">{{item.goods_name}}</p>
      <p class="fen fen_money">
        <span>¥ {{item.price}}/天</span>
        <img src="/static/img/icon-zuwuche-nor.png" @click.stop="addToCart(item)" title="加入购物车">
      </p>
      <p class="fen fen_num">
        <router-link :to="{path:'/supplierDetail', query:{id:item.supplier_id}}" target="_blank" @click.native.stop="jump(item.supplier_id)">
        <span class="supplier-name pointer">{{item.supplier_name}}</span>
        </router-link>
        <span>已租：{{item.sales_volume}}</span>
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: "indexProduct",
  props: ["item"],
  methods: {
    addToCart(item) {
      this.$emit("transferData", item);
      // this.$store.dispatch("userOrder/changeCartNumAction");
    },
    jump(id){
      // this.$router.push({
      //   path:'supplierDetail',
      //   query:{
      //     id:id
      //   }
      // })
    }
  }
};
</script>


<style scoped>
.cate-product .el-image {
  width: 100%;
  transition: All 0.4s ease-in-out;
  -webkit-transition: All 0.4s ease-in-out;
  -moz-transition: All 0.4s ease-in-out;
  -o-transition: All 0.4s ease-in-out;
}
.cate-product:hover .el-image {
  transform: scale(1.1);
  -webkit-transform: scale(1.1);
  -moz-transform: scale(1.1);
  -o-transform: scale(1.1);
  -ms-transform: scale(1.1);
}
.product-box {
  padding: 10px;
}
.goods_name {
  font-size: 12px;
  color: #333;
  height: 36px;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
.fen {
  display: flex;
  justify-content: space-between;
}
.fen_money {
  font-size: 14px;
  color: #eb2525;
}
.fen_money img {
  width: 15px;
  height: 12px;
  cursor: pointer;
}
.fen_num {
  font-size: 12px;
  color: #999;
}
.supplier-name:hover{
  color:red;
  text-decoration: underline;
}
</style>




// WEBPACK FOOTER //
// src/components/cateProduct.vue